import enCustom from '@/i18n/langs/en.json'

export default {
  ...enCustom
}
